import React, { useState } from "react";
import { MoveRight, X } from "lucide-react";
import { todayISO } from "./boardUtils";

export const BoardBulkBar = ({ count, staff, onMove, onClear }) => {
  const [date, setDate] = useState(todayISO());
  const [who, setWho] = useState("__keep");
  return (
    <div className="sticky top-0 z-30 mb-3 flex flex-wrap items-center gap-2 rounded-2xl bg-slate-900 text-white px-4 py-2.5 shadow-lg" data-testid="board-bulk-bar">
      <span className="font-bold text-sm" data-testid="board-bulk-count">{count} magnet{count === 1 ? "" : "s"} selected</span>
      <span className="text-xs text-white/60">drag any one of them to move them all, or:</span>
      <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="board-bulk-date" className="rounded-full bg-white text-slate-900 text-sm font-semibold px-3 py-1" />
      <select value={who} onChange={(e) => setWho(e.target.value)} data-testid="board-bulk-assignee" className="rounded-full bg-white text-slate-900 text-sm font-semibold px-3 py-1.5">
        <option value="__keep">Keep same person</option>
        {staff.map((s) => <option key={s} value={s}>{s}</option>)}
        <option value="">Everyone</option>
      </select>
      <button onClick={() => onMove(who === "__keep" ? undefined : who, date)} disabled={!count || !date} data-testid="board-bulk-move-btn"
        className="rounded-full bg-amber-500 hover:bg-amber-600 text-sm font-bold px-4 py-1.5 inline-flex items-center gap-1 disabled:opacity-40"><MoveRight className="h-4 w-4" />Move</button>
      <button onClick={onClear} data-testid="board-bulk-clear-btn" className="ml-auto text-sm font-bold text-white/70 hover:text-white inline-flex items-center gap-1"><X className="h-4 w-4" />Clear</button>
    </div>
  );
};
